import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { SelectOption } from '@common/types/common';
import { LanguageResponse } from '../types/Translation';

const translationApi = createApi({
    reducerPath: 'translationApi',
    baseQuery: fetchBaseQuery({
        baseUrl: '/',
        credentials: 'same-origin',
    }),
    keepUnusedDataFor: 1800,
    endpoints: (builder) => ({
        getLanguages: builder.query<SelectOption[], void>({
            query: () => 'api-professional/public/translations/languages/',
            transformResponse: (response: LanguageResponse[]) =>
                response.map((language) => ({
                    value: language.code,
                    label: language.name,
                })),
        }),
    }),
});

export const { useGetLanguagesQuery } = translationApi;

export default translationApi;
